import * as TSE from 'ts-events';
import { ObjectWithId } from './../../../util/object-with-id';

export abstract class AbstractDataFilter extends ObjectWithId {
    public filterUpdatedEvent = new TSE.SyncEvent(); // only used by mergers!
    public filterDeletedEvent = new TSE.SyncEvent(); // only used by mergers!
    public filteredData: any[] = [];
    public anyFilterApplied: boolean = false;
    public lastFilterParameters: { enabled: boolean } = { enabled: true };

    public constructor() {
        super();
    }

    protected abstract executeInternal(parameters: { enabled: boolean }): void;

    public destroy() {
        this.filterUpdatedEvent.detach();

        this.filterDeletedEvent.post(); // inform mergers about delete
        this.filterDeletedEvent.detach();
    }

    public reset() {
        this.lastFilterParameters = { enabled: true };
        this.filterUpdatedEvent.post();
    }

    public execute(parameters: any) {
        this.lastFilterParameters = parameters;
        this.executeInternal(parameters);
        this.filterUpdatedEvent.post();
    }
}
